import * as React from "react";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { translate, InjectedTranslateProps } from "react-i18next";
import { ConnectedDateSelect } from "./date-select";
import { ConnectedMobileMenu } from "./mobile-menu";

export interface PrintViewItemsProps {}

interface ConnectedPrintViewItemsProps extends WithStyles<typeof styles> {
	layout: "desktop" | "tablet" | "phone";
}

type Props = PrintViewItemsProps &
	ConnectedPrintViewItemsProps &
	InjectedTranslateProps;

export class PrintViewItems extends React.Component<Props, {}> {
	public render() {
		const { classes, layout } = this.props;

		return (
			<React.Fragment>
				<ConnectedDateSelect />
				<div className={classes.flexExpand} />
				{layout === "phone" && <ConnectedMobileMenu />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	layout: state.layout
});

const styles = (theme: Theme) =>
	createStyles({
		flexExpand: {
			flexGrow: 1
		}
	});

export const ConnectedPrintViewItems = translate("translations")(
	withStyles(styles)(connect(mapStateToProps)(PrintViewItems))
);
